import React from "react";
import { FiLoader } from "react-icons/fi";
import { getCardConfig } from "../utils";

const SummaryCard = ({ card, onClick, loading }) => {
  const cfg = getCardConfig(card.cardName);
  return (
    <div
      className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:shadow-md cursor-pointer"
      onClick={onClick}
    >
      <div className={`p-6 text-white ${cfg.accent}`}>
        <div className="mb-2 flex items-center gap-2">
          <span className="text-lg">{cfg.icon}</span>
          <span className="text-sm font-semibold uppercase tracking-wide opacity-90">
            {card.cardName}
          </span>
        </div>
        <div className="flex items-baseline gap-2">
          {loading ? (
            <>
              <FiLoader className="h-8 w-8 animate-spin opacity-80" />
              <span className="text-lg opacity-80">Loading...</span>
            </>
          ) : (
            <>
              <span className="text-4xl font-bold leading-none">
                {Number(card?.cardValue ?? 0).toFixed(0)}
              </span>
              <span className="text-xl opacity-80">Rs Cr</span>
            </>
          )}
        </div>
        <p className="mt-1 text-xs opacity-70">
          {card.monthYear?.replace("_", " ") || ""}
        </p>
      </div>
    </div>
  );
};

export default SummaryCard;
